import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'idIncluded',
  standalone: true
})
export class IdIncludedPipe<T> implements PipeTransform {
  private includesId(id: T, referenceId: T ): boolean {
    return id === referenceId;
  }

  transform(ids: T[],  referenceId: T, compareFn?: (a:T, b:T)=> boolean): boolean {
    if (ids && referenceId) {
      return ids.some((id) => compareFn?  compareFn(id, referenceId): this.includesId(id, referenceId));
    }
    return false;
    }

}
